import { Http } from "../utils/http.js";
class Usercenter extends Http {
  addressByCustomsId(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/GetAddressByCustomsId",
      method: "post",
      param: param
    });
  }

  createAddress(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/CreateAddress",
      method: "post",
      param: param
    });
  }

  updateAddress(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/UpdateAddress",
      method: "post",
      param: param
    });
  }

  deleteAdress(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/DeleteAdress",
      method: "post",
      param: param
    });
  }

  defaultAddress(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Customer/SetDefaultAddress",
      method: "post",
      param: param
    });
  }

  listOrderCount(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/ListOrderCount",
      method: "post",
      param: param
    });
  }

  listOrder(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/ListOrder",
      method: "post",
      param: param
    });
  }

  reminder(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/reminder",
      method: "post",
      param: param
    });
  }
  confirmReceipt(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/ConfirmReceipt",
      method: "post",
      param: param
    });
  }
  logistics(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/Logistics",
      method: "post",
      param: param
    });
  }

  myLikeArtistList(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Artist/myLikeArtistList",
      method: "post",
      param: param
    });
  }

  myOfferPrice(param) {
    let _this = this;
    return _this.request({
      url: "/WebApi/Customer/MyOfferPrice",
      method: "post",
      param: param
    });
  }

  createNativePayOrder(param) {
    let _this = this;
    return _this.request({
      url: "/WebApi/Order/CreateNativePayOrder",
      method: "post",
      param: param
    });
  }

  payInfo(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/PayInfo",
      method: "post",
      param: param
    });
  }
  payOrderQuery(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Payment/PayOrderQuery",
      method: "post",
      param: param,
      load: true
    });
  }
  refundDeposit(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Order/RefundDeposit",
      method: "post",
      param: param
    });
  }
}
export { Usercenter };
